import React from 'react';
import { PageHeader } from '../components/ui/PageHeader';
import { PendingNote } from '../components/ui/PendingNote';
import { sceneImages } from '../data/images';
const principles = [{
  title: 'Optics',
  body: 'Thirteen 5050 LED lenses in the manufacturer’s original arrangement behind a textured front surface, for an even, diffused wash of color.'
}, {
  title: 'Enclosure',
  body: 'A white ABS circular housing, 3.3 in across and 1.2 in thick. ABS does not rust like exposed ferrous metal.'
}, {
  title: 'Power',
  body: 'An internal 3000 mAh rechargeable battery at 5 V / 3 W, charged by USB-C behind a blue protective cover.'
}, {
  title: 'Mounting',
  body: 'A matched-diameter magnetic base that stays installed while the light lifts off for charging.'
}];
const process = [{
  phase: 'Specification',
  body: 'Define the lighting system around homeowner installation, not electrician installation.'
}, {
  phase: 'Supplier validation',
  body: 'Confirm advertised performance — IP rating, run time, color options — before publication.'
}, {
  phase: 'Quality inspection',
  body: 'Individual inspection and functionality testing before shipment is planned. The program will be described here once it is operational and documented.',
  pending: true
}, {
  phase: 'Field feedback',
  body: 'Warranty and support data feed the next generation.'
}];
export function Engineering() {
  return <>
      <PageHeader image={sceneImages.waterTexture} title={<>
            Professional-Grade <span className="text-ice" data-id="element-1116" data-mp="1r0v3e5fadnse">Engineering.</span>
          </>} lead="Engineered for a brighter tomorrow. How the M1 PRO is designed around the realities of water, weather and the homeowners who use it — professional quality with effortless installation." data-id="element-1115" data-mp="20sio7nhc86kw" />

      <section className="mx-auto max-w-site px-5 py-14 md:px-8 md:py-20" data-id="element-1117" data-mp="2jj0hbt63146s">
        <h2 className="font-display text-4xl font-semibold uppercase md:text-5xl" data-id="element-1118" data-mp="2ep4kwv5gvpdq">Design principles</h2>
        <dl className="mt-8 grid gap-x-16 gap-y-10 md:grid-cols-2" data-id="element-1119" data-mp="ctoxzwglgxt7">
          {principles.map(p => <div key={p.title} className="border-t mf-hairline pt-6" data-id="element-1120" data-mp="hu2wonwb2vek">
              <dt className="font-display text-3xl font-semibold uppercase" data-id="element-1121" data-mp="32avdftcjhvu">{p.title}</dt>
              <dd className="mt-3 max-w-lg text-titanium" data-id="element-1122" data-mp="815d0efkv0ed">{p.body}</dd>
            </div>)}
        </dl>
        <p className="mt-10 text-sm text-titanium/70" data-id="element-1123" data-mp="3q70cx7rbh640">
          Electrical and battery figures are manufacturer-advertised.
        </p>
      </section>

      <section aria-labelledby="process-title" className="border-y mf-hairline bg-navy" data-id="element-1124" data-mp="3g9vqd6tk78mo">
        <div className="mx-auto max-w-site px-5 py-14 md:px-8 md:py-20" data-id="element-1125" data-mp="3l8p85bfvplsn">
          <h2 id="process-title" className="font-display text-4xl font-semibold uppercase md:text-5xl" data-id="element-1126" data-mp="3l8yver9jheun">
            Development process
          </h2>
          <ol className="relative mt-8 space-y-8 border-l border-titanium/20 pl-8" data-id="element-1127" data-mp="1jhlv6fiinv4x">
            {process.map((p, i) => <li key={p.phase} className="relative" data-id="element-1128" data-mp="34065hz0slydw" data-mpi={i}>
                <span className="absolute -left-[45px] flex h-7 w-7 items-center justify-center rounded-full border border-marine bg-navy text-xs font-semibold text-marine" data-id="element-1129" data-mp="2z0jqpl5bga2z">
                  {i + 1}
                </span>
                <h3 className="font-display text-2xl font-semibold uppercase" data-id="element-1130" data-mp="38y7ko8v3ldk3">
                  {p.phase}
                  {p.pending && <PendingNote data-id="element-1131" data-mp="3moky2qqrdkgt">Owner to define</PendingNote>}
                </h3>
                <p className="mt-1.5 max-w-xl text-titanium" data-id="element-1132" data-mp="3hprfwl0j15ab">{p.body}</p>
              </li>)}
          </ol>
        </div>
      </section>

      <section className="mx-auto max-w-site px-5 py-20 md:px-8" data-id="element-1133" data-mp="gbifm6ncv44">
        <PendingNote tone="block" data-id="element-1134" data-mp="3rqa4tu6y7bz3">
          No certifications, laboratory test results, depth ratings, temperature ranges or brightness measurements are
          claimed. These will be published only once substantiated.
        </PendingNote>
      </section>
    </>;
}